/**
 * @fileoverview added by tsickle
 * Generated from: models/area.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { model } from '../util/model';
/** @type {?} */
var MAX_VISIBLE_AREA_NAME_LENGTH = 25;
/** @type {?} */
var AREA_NAME_SLICE_LENGTH = MAX_VISIBLE_AREA_NAME_LENGTH - 3;
/**
 * Model representing an area.
 * @record
 */
export function Area() { }
if (false) {
    /** @type {?} */
    Area.prototype.code;
    /** @type {?} */
    Area.prototype.localDisplayName;
    /** @type {?} */
    Area.prototype.extraJobAreaDisplayName;
}
/** @type {?} */
export var area = model.extend({
    modelName: 'area',
    postConstruct: /**
     * @return {?}
     */
    function () {
        this.extraJobAreaDisplayName = this.localDisplayName || '';
        if (this.extraJobAreaDisplayName.length > MAX_VISIBLE_AREA_NAME_LENGTH) {
            this.extraJobAreaDisplayName = this.extraJobAreaDisplayName.slice(0, AREA_NAME_SLICE_LENGTH) + '...';
        }
    }
});
